import { render, staticRenderFns } from "./CategoryEdit.vue?vue&type=template&id=234bf37f&scoped=true&"
import script from "./CategoryEdit.vue?vue&type=script&lang=js&"
export * from "./CategoryEdit.vue?vue&type=script&lang=js&"
import style0 from "./CategoryEdit.vue?vue&type=style&index=0&id=234bf37f&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "234bf37f",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/m1292/Documents/develop/laravel/cure-naruhodoga/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('234bf37f')) {
      api.createRecord('234bf37f', component.options)
    } else {
      api.reload('234bf37f', component.options)
    }
    module.hot.accept("./CategoryEdit.vue?vue&type=template&id=234bf37f&scoped=true&", function () {
      api.rerender('234bf37f', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/js/components/designed/admin/CategoryEdit.vue"
export default component.exports